/** Backend identifier for walk-in customer (do not translate for API payloads). */
export const WALK_IN_CUSTOMER_ID = 'Walk in Customer';

/**
 * Checks whether a given customer name or ID represents a walk-in customer.
 * Returns true if the string is empty or matches variations of 'Walk in Customer', 'Walk In', etc.
 */
export function isWalkInCustomer(customerOrName?: string | null): boolean {
  if (!customerOrName || !customerOrName.trim()) return true;
  const n = customerOrName.trim().toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ');
  return (
    n === 'walk in' ||
    n === 'walk in customer' ||
    n === 'walkin' ||
    n === 'walkin customer'
  );
}
